import { render, staticRenderFns } from "./JitsiMeeting.vue?vue&type=template&id=4091d97d&"
import script from "./JitsiMeeting.vue?vue&type=script&lang=js&"
export * from "./JitsiMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4091d97d')) {
      api.createRecord('4091d97d', component.options)
    } else {
      api.reload('4091d97d', component.options)
    }
    module.hot.accept("./JitsiMeeting.vue?vue&type=template&id=4091d97d&", function () {
      api.rerender('4091d97d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Information/JitsiMeeting.vue"
export default component.exports